import { ORDER_VALIDATION_CODES } from "@the-drop/types";
import { complianceDeliveryAddressUrl, complianceDeliveryZipUrl, } from "./url-builders";
export async function fetchDeliveryZipPermitted(baseUrl, rawZip) {
    const trimmed = rawZip.trim();
    if (trimmed === "") {
        return { ok: false, kind: "bad_request" };
    }
    const url = complianceDeliveryZipUrl(baseUrl, trimmed);
    let res;
    try {
        res = await fetch(url);
    }
    catch {
        return { ok: false, kind: "network" };
    }
    if (res.status === 200) {
        try {
            const body = (await res.json());
            if (body.permitted === true && typeof body.zip === "string" && body.zip.length === 5) {
                return { ok: true, zip: body.zip };
            }
        }
        catch {
            /* fall through */
        }
        return { ok: false, kind: "http", status: res.status };
    }
    if (res.status === 422) {
        try {
            const body = (await res.json());
            if (body.code === ORDER_VALIDATION_CODES.JURISDICTION_NOT_PERMITTED &&
                typeof body.zip === "string") {
                return { ok: false, kind: "not_permitted", zip: body.zip };
            }
        }
        catch {
            /* fall through */
        }
        return { ok: false, kind: "http", status: 422 };
    }
    if (res.status === 400) {
        try {
            const body = (await res.json());
            if (body.error === "invalid_delivery_zip") {
                return { ok: false, kind: "invalid_zip" };
            }
        }
        catch {
            /* fall through */
        }
        return { ok: false, kind: "bad_request" };
    }
    return { ok: false, kind: "http", status: res.status };
}
/**
 * Decides whether the picked address is deliverable under Colorado MED
 * Rule 3-615(B). Discriminated result; network and HTTP failures are
 * surfaced as their own variants so the UI can distinguish "rejected by
 * policy" from "couldn't reach the check server".
 */
export async function fetchDeliveryAddressAllowed(baseUrl, req) {
    let res;
    try {
        res = await fetch(complianceDeliveryAddressUrl(baseUrl), {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(req),
        });
    }
    catch {
        return { ok: false, source: "network" };
    }
    if (!res.ok) {
        return { ok: false, source: "http", status: res.status };
    }
    let parsed;
    try {
        parsed = await res.json();
    }
    catch {
        return { ok: false, source: "http", status: res.status };
    }
    return parsed;
}
//# sourceMappingURL=compliance.js.map